module.exports = __webpack_public_path__ + "static/media/Notification.fb183c5e.svg";